module.exports = __webpack_public_path__ + "static/media/leaf.fb599f5d.png";